import { EventRegistry } from '../../../../../domain/event/event.registry';
import { AssetClassEvent } from './asset-class.event';
export class AssetClassNameSetEvent extends AssetClassEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.id}`,
            type: AssetClassNameSetEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetClassNameSetEvent.type = 'com.treeplotter.api.asset-class.nameSet.v1';
EventRegistry.register(AssetClassNameSetEvent.type, AssetClassNameSetEvent);
//# sourceMappingURL=asset-class-name-set.event.js.map